module.exports = __webpack_public_path__ + "img/1.df794d33.png";